module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c2/main_pc_e1189bf57163eca4f565ee924ca62eb5.jpg";